import { useStyletron } from '@/camo/utils/theme'
import { Spinner as BaseSpinner, type SpinnerProps } from 'baseui/spinner'

const Spinner = ({ $color, ...props }: SpinnerProps) => {
  const [, theme] = useStyletron()
  return <BaseSpinner data-testid="spinner" {...props} $color={$color ? $color : theme.colors.primary} />
}

export { Spinner }
